// imports
import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/lib/ui';
import userReducer from './slices/lib/user';
import configReducer from './slices/lib/config';

// interfaces / types / consts
const store = configureStore({
  reducer: {
    ui: uiReducer,
    user: userReducer,
    config: configReducer
  },
  devTools: process.env.REACT_APP_ENVIRONMENT !== 'prod'
});

// exports
export type RootState = ReturnType<typeof store.getState>;
export default store;
